import styled from '@emotion/styled';

const ModalContainer = styled.div`
    padding: 42px 16px 20px;
`;

export default ModalContainer;
